export default {
  common: {
    loading: 'Memuat',
    confirm: 'Konfirmasi',
    cancel: 'Batal',
    save: 'Simpan',
    back: 'Kembali',
    copy: 'Salin',
    delete: 'Hapus',
    copySuccess: 'Berhasil disalin',
    editSuccess: 'Berhasil diedit',
    deleteSuccess: 'Berhasil dihapus',
    modifySuccess: 'Berhasil diperbarui',
    cannotBeEmpty: 'Tidak boleh kosong',
    noContent: 'Tidak ada konten',
    noData: 'Tidak ada data terkait',
    noMoreData: 'Tidak ada data lagi',
    iKnow: 'Saya mengerti',
    selectService: 'Pilih penyedia layanan',
    sendSuccess: 'Berhasil dikirim',
  },
  billHome: {
    recharge: 'Isi Ulang & Pembayaran',
    coupon: 'Kupon',
    rechargeNow: 'Isi Ulang Sekarang',
    cost: 'Pulsa',
    flow: 'Data',
    rechargeNotice: 'Panduan isi ulang',
    rechargeCost: 'Isi ulang pulsa',
    rechargeFlow: 'Isi ulang data',
    rechargeAmount: 'Jumlah isi ulang',
    rechargePackage: 'Paket isi ulang',
    discount: 'Diskon diterapkan',
    confirmTxt: 'Sudah benar',
    confirmTxt1: 'Saya mengerti',
    actualPayment: 'Total Bayar',
    selectCoupon: 'Pilih kupon',
    useRule: 'Aturan penggunaan',
    availableCoupon: 'Kupon yang tersedia',
    unavailableCoupon: 'Kupon tidak tersedia',
    noAvailableCoupon: 'Tidak ada kupon yang tersedia',
    selectPhone: 'Pilih nomor ponsel',
    pleaseInputPhone: 'Masukkan nomor ponsel',
    couponCount: 'Kupon tersedia',
    pleaseInputCorrectPhone: 'Silakan masukkan nomor telepon yang benar',
    pleaseSelectPackage: 'Silakan pilih paket isi ulang',
  },
  accountManage: {
    title: 'Kelola Akun',
    edit: 'Edit',
    deleteConfirm: 'Yakin ingin menghapus?',
  },
  rechargeDetail: {
    title: 'Detail Pembayaran',
    continuePay: 'Lanjutkan pembayaran',
  },
  feesExpense: {
    title: 'Riwayat Pembayaran',
    recharge: 'Nomor telepon',
    electricity: 'Listrik',
    internet: 'Internet',
    water: 'Air',
    photo: 'Foto',
    complete: 'Selesai',
    manage: 'Kelola',
    allSelect: 'Pilih Semua',
    selected: 'Terpilih',
    deleteConfirm: 'Hapus',
    deleteRecord: 'riwayat pembayaran ini?',
    noDataAction: 'Tidak ada data yang dapat dikelola',
    pleaseSelect: 'Silakan pilih data yang akan dihapus',
    feesNotice: 'Panduan pembayaran',
  },
  formCom: {
    upload: 'Klik untuk unggah',
    saveAccount: 'Simpan atau perbarui akun',
    createOrder: 'Buat Pesanan',
    rechargeIng: 'Sedang mengisi ulang',
    rechargeNow: 'Isi Ulang Sekarang',
    serviceProvider: 'Penyedia layanan',
    billImage: 'Gambar tagihan',
    returnSelect: 'Kembali untuk memilih ulang',
    electricity: 'Tagihan listrik',
    internet: 'Tagihan internet',
    water: 'Tagihan air',
    photo: 'Bayar lewat foto',
    life: 'Pembayaran utilitas',
    uploadFail: 'Unggahan gagal, silakan coba lagi',
    pleaseFill: 'Harap isi semua informasi',
    submitSuccess: 'Berhasil dikirim, menunggu pembayaran',
  },
  langPop: {
    selectLang: 'Pilih Bahasa',
  },
  loginPop: {
    loginOrRegister: 'Silakan login atau daftar akun Kuaizi',
    confirmLogout: 'Apakah Anda yakin ingin logout?',
    toLogin: 'Masuk',
    logoutSuccess: 'Berhasil logout',
  },
  newMe: {
    myOrder: 'Pesanan Saya',
    coupon: 'Kupon',
    accountManage: 'Kelola Akun',
    orderCount: 'pesanan sedang diproses',
    couponCount: 'kupon',
    account: 'Akun',
    logout: 'Keluar',
  },
  coupons: {
    all: 'Semua',
    coupon: 'Kupon',
    historyCoupon: 'Riwayat kupon',
    use: 'Gunakan',
    validityPeriod: 'Masa berlaku',
    useRule: 'Aturan penggunaan',
    used: 'Telah digunakan',
    expired: 'Kadaluarsa',
  },
  accountSeting: {
    title: 'Pengaturan',
    personalInfo: 'Informasi Pribadi',
    modifyPayPassword: 'Ubah sandi pembayaran',
    modifyLoginPassword: 'Ubah sandi login',
    phone: 'Nomor Ponsel',
    code: 'Kode verifikasi',
    loginPassword: 'Kata sandi masuk',
    confirmModify: 'Konfirmasi perubahan',
    noCode: 'Tidak menerima kode?',
    passwordPlaceholder: '8–16 karakter kombinasi huruf dan angka',
    inputCorrectPhone: 'Masukkan nomor yang valid',
    afterGetCode: 'dapat mengambil ulang setelah',
    getCode: 'Dapatkan kode',
    input6DigitPassword: 'Masukkan 6 digit sandi',
    twoInputPasswordNotConsistent: 'Kata sandi tidak cocok',
    placeholderCode: 'Masukkan kode verifikasi',
    confirmPassword: 'Konfirmasi kata sandi',
    password: 'Kata sandi',
    submit: 'Kirim',
    avatar: 'Foto Profil',
    userName: 'Nama Pengguna',
    nickName: 'Nama Panggilan',
    modifyPhone: 'Ubah nomor ponsel',
    nickNamePlaceholder: 'Tunjukkan gaya Anda',
    sex: 'Jenis Kelamin',
    male: 'Laki-laki',
    female: 'Perempuan',
    email: 'Email',
    emailPlaceholder: 'Tambahkan email untuk pemulihan kata sandi',
    pleaseCompletePersonalData: 'Lengkapi data pribadi Anda untuk menikmati fitur lebih banyak',
    bindNewPhone: 'Hubungkan nomor baru',
    oldPhone: 'Nomor Lama',
    completeVerification: 'Selesaikan Verifikasi',
    changePayPasswordTitle: 'Ubah Kata Sandi Pembayaran',
    changePasswordTitle: 'Ubah Kata Sandi',
    oldPhoneTitle: 'Verifikasi Nomor Lama',
    editInfoTitle: 'Edit Profil',
    areaCode: 'Kode area',
  },
}
